import { Component, Inject } from "@angular/core";
import { StateService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { WorkSchedulesDataService } from "../core/workschedules.dataservice";
import { DetailsBase } from "../settings/shared/details.base";

@Component({
    selector: "crew-work-schedule",
    template: require('./work-schedule.component.html')
})
export class WorkScheduleComponent extends DetailsBase<Nema.Crew.Model.WorkSchedule> {

    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('workSchedule') workScheduleEntity: Nema.Crew.Model.WorkSchedule,
        @Inject(WorkSchedulesDataService.Id) workScheduleDataService: WorkSchedulesDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, workScheduleEntity, workScheduleDataService, $log);

        (<any>this.entity.Steps).load();
    }

    public entityName = "Work Schedule";

    public editStateName = "app.activities.workschedules.edit";

    public listStateName = "app.activities.workschedules";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/work-schedule.component.ts